import React, {Component} from 'react';
import {getDefaultExposure} from 'helpers/player-helper';
import NumberHelper from 'helpers/number-helper';

class ComboExposureMax extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {value: null};
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(incomingValue) {
        const value = this.prepareValue(incomingValue);

        this.onChange(value);
        this.isValueBeingChanged = false;

        this.setExposureMaxForCombo(value);
    }

    setExposureMaxForCombo(value) {
        const {stackItemId: stackId, combo, buildId} = this.props;
        this.props.dispatch(this.action.set('ExposureMaxForCombo', {buildId, stackId, combo, value}));
    }

    prepareValue(value) {
        const defaultExpMax = getDefaultExposure('max');
        return NumberHelper.prepareInt(value, defaultExpMax).limitByRange(0, defaultExpMax, defaultExpMax).get();
    }

    getDefaultValue() {
        return getDefaultExposure('max');
    }

    getActualValue() {
        const {stackItemId, combo, comboExpMax, buildId} = this.props;
        let value = this.getDefaultValue();
        if (this.isValueBeingChanged) {
            value = this.state.value;
        } else if (comboExpMax.hasStackCombo(buildId, stackItemId, combo)) {
            value = comboExpMax.getStackCombo(buildId, stackItemId, combo).getExpMax();
        }
        return value;
    }

    render() {
        const {className} = this.props;

        return (
            <input
                className={className}
                value={`${this.getActualValue()}`}
                onChange={(e) => this.onChange(e.target.value)}
                onBlur={(e) => this.onBlur(e.target.value)}
            />
        );
    }
}

export {ComboExposureMax};
